import React, { useEffect, useState } from "react";
import CommonHeadingNBtns from "../../../components/common-components/CommonHeadingNBtns";
import { useGetFetchNew } from "../../../data/Queries";
import { top_users } from "../../../data/ApiEndpoints";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import Loader from "../../../components/ui/Loader";
import FilterContainer from "../../../components/common-components/filters/filter-container";
import GymFilter from "../../../components/common-components/filters/gym-filter";
import { tbAllMembersColumns } from "./TopGymUtils";
import CustomDropDownFilter from "../../../components/common-components/filters/CustomDropDownFilter";
import DateRangerFilter from "../../../components/common-components/filters/date-ranger-filter";

const TopGymDetail = ({ closeModal, selectedGym, userInfoData }) => {
  const iniAllFilters = {
    gym_id: selectedGym?.gym_id,
    coin_type: "",
    sort_by_coin: "",
    start_date: "",
    end_date: "",
  };

  const [filters, setFilters] = useState(iniAllFilters);

  const { data, isLoading, refetch } = useGetFetchNew({
    token: userInfoData?.token,
    key: "top_gyms_details",
    url: `${top_users}`,
    filters: {
      gym_id: filters?.gym_id,
      sort_by_coin: filters?.sort_by_coin?.value,
      coin_type: filters?.coin_type,
      start_date: filters?.start_date,
      end_date: filters?.end_date,
    },
  });

  const [page, setPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  useEffect(() => {
    refetch();
  }, [selectedGym, filters]);

  const handleReset = () => {
    setPage(0);
    setPageLimit(10);
    setFilters({
      ...iniAllFilters,
      coin_type: "",
      sort_by_coin: "",
    });
  };

  const selectedGymFormatted = {
    label: selectedGym?.gym_name,
    value: selectedGym?.gym_id,
  };

  const orderFormatted = [
    {
      label: "Newest to Oldest",
      value: "desc",
    },
    {
      label: "Oldest to Newest",
      value: "asc",
    },
  ];

  // console.log("filters", filters);

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <CommonHeadingNBtns
        title={`All Members`}
        isLoading={false}
        // btnTxt={"Save"}
        onClose={closeModal}
      />
      <br />

      <FilterContainer onReset={handleReset}>
        <GymFilter
          selectedGym={selectedGymFormatted}
          setSelectedGym={(value) => {
            setFilters({ ...filters, gym_id: value?.value });
          }}
        />
        <CustomDropDownFilter
          options={orderFormatted}
          name="Sort by coins earned"
          selectedOption={
            filters?.coin_type === "earn" ? filters?.sort_by_coin : null
          }
          setSelectedOption={(value) => {
            if (!value) {
              setFilters({ ...filters, sort_by_coin: "", coin_type: "" });
            } else {
              setFilters({
                ...filters,
                sort_by_coin: value,
                coin_type: "earn",
              });
            }
          }}
        />
        <CustomDropDownFilter
          options={orderFormatted}
          name="Sort by coins spent"
          selectedOption={
            filters?.coin_type === "spent" ? filters?.sort_by_coin : null
          }
          setSelectedOption={(value) => {
            if (!value) {
              setFilters({ ...filters, sort_by_coin: "", coin_type: "" });
            } else {
              setFilters({
                ...filters,
                sort_by_coin: value,
                coin_type: "spent",
              });
            }
          }}
        />

        <DateRangerFilter
          startDate={filters.start_date || ""}
          endDate={filters.end_date || ""}
          onDateChange={(startDate, endDate) =>
            setFilters({ ...filters, start_date: startDate, end_date: endDate })
          }
        />
      </FilterContainer>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        {isLoading ? (
          <div className="flexCenter" style={{ minHeight: "200px" }}>
            <Loader />
          </div>
        ) : (
          <PaymentLinkTable
            tableColumns={tbAllMembersColumns}
            tableData={data?.data}
            isPage={page}
            setIsPage={(value) => setPage(value)}
            isLoading={isLoading}
            tablePagination={data?.pagination}
            setPageLimit={(value) => setPageLimit(value)}
            pageLimit={pageLimit}
          />
        )}
      </div>
    </div>
  );
};

export default TopGymDetail;
